import { Capacitor } from "@capacitor/core";
import { EdgeToEdge } from "@capawesome/capacitor-android-edge-to-edge-support";

const LEGACY_PLUGIN_TIMEOUT_MS = 1_500;

let viewportSetupPromise: Promise<void> | undefined;

const disableLegacyEdgeToEdge = async (): Promise<void> => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  const pluginCall = Promise.resolve()
    .then(() => EdgeToEdge.disable())
    .catch((error) => {
      console.error("Failed to neutralize legacy Android edge-to-edge margins", error);
    });

  const timeout = new Promise<void>((resolve) => {
    timeoutId = setTimeout(() => {
      console.warn(
        `Legacy Android edge-to-edge bridge did not respond within ${LEGACY_PLUGIN_TIMEOUT_MS}ms; continuing startup`,
      );
      resolve();
    }, LEGACY_PLUGIN_TIMEOUT_MS);
  });

  await Promise.race([pluginCall, timeout]);

  if (timeoutId !== undefined) {
    clearTimeout(timeoutId);
  }
};

const setupViewportOnce = async (): Promise<void> => {
  if (Capacitor.getPlatform() !== "android") {
    return;
  }

  // The installed Capawesome plugin enables WebView margins as soon as its
  // native plugin loads. Neutralize those margins so Capacitor 8 SystemBars
  // remains the single owner of system-bar and keyboard insets. This is an
  // optional compatibility adjustment and must never prevent the app loading
  // when an older native shell cannot answer the newer plugin bridge call.
  await disableLegacyEdgeToEdge();
};

export const setupViewport = async () => {
  if (!viewportSetupPromise) {
    viewportSetupPromise = setupViewportOnce();
  }

  await viewportSetupPromise;
};
